import { intercept } from "@ispb/react-hooks"
import { LazyContext } from "@ispb/react-lazy"
import { compose } from "ramda"
import { createElement, useEffect } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import NotFound from "ui/components/NotFound"
import { useSearchParam } from "ui/hoc"
import { PAGE_LAZY } from "ui/lazy/index"
import WithTitle from "ui/title/WithTitle"
import { APP_NAME, BASE_URL } from "../config.js"
import Boundary from "./Boundary.js"
import { useAnonymous } from "./index.js"
import Lookup from "./Lookup.js"
import Scan from "./Scan.js"

const component = compose(
    intercept(() => {
        return {
            type: "replace",
            element: component => {
                return (
                    <WithTitle title={APP_NAME}>
                        <div className="d-flex flex-column min-vh-100">
                            <LazyContext.Provider value={PAGE_LAZY}>
                                <BrowserRouter basename={BASE_URL}>
                                    <ErrorBoundary FallbackComponent={Boundary}>
                                        {createElement(component)}
                                    </ErrorBoundary>
                                </BrowserRouter>
                            </LazyContext.Provider>
                        </div>
                    </WithTitle>
                )
            }
        }
    })
)(() => {
    const [name] = useSearchParam("name")
    const [companyName] = useSearchParam("companyName")
    const anonymous = useAnonymous()
    useEffect(() => {
        if (name !== undefined && companyName !== undefined) {
            anonymous[1]({ name, companyName })
        }
    }, [
        name,
        companyName,
    ])
    return (
        <Routes>
            <Route path=":barCode/*" element={<Lookup />} />
            <Route path=":barCode/:pin/*" element={<Lookup />} />
            <Route path="" element={<Scan />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    )
})

export default function App(...args: Parameters<typeof component>) {
    return component(...args)
}
